import { styled } from '@mui/system';
import { Box } from '@mui/material';

import Header from './Header';
import Row from './Row';
import { useDailyTimesheetsState } from '../useDailyTimesheets';
import { TimesheetsNoDataFound } from '../../../components';

const StyledDataTableContainer = styled(Box)(({ theme: { spacing } }) => ({
    width: `calc(100% - ${spacing(8)})`,
    margin: `${spacing(2)} ${spacing(4)}`
}));

const DataTable = () => {
    const { data: attendances } = useDailyTimesheetsState();
    return (
        <StyledDataTableContainer>
            <Header />
            {attendances.length === 0 ? (
                <TimesheetsNoDataFound />
            ) : (
                attendances.map((attendance, idx) => (
                    <Row
                        key={`daily-all-timesheets-${idx}`}
                        isOdd={(idx + 1) % 2 === 1}
                        {...attendance}
                    />
                ))
            )}
        </StyledDataTableContainer>
    );
};

export default DataTable;
